import { connect } from 'react-redux';
import { trackFilterArticles, toggleFilter } from '../actions';
import Filter from '../components/filter/';

export default connect(
  null,
  dispatch => ({
    trackFilterArticles: payload => dispatch(trackFilterArticles(payload)),
    toggleFilter: () => dispatch(toggleFilter()),
  })
)(Filter);



// WEBPACK FOOTER //
// ./src/containers/filter.js